import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { fetchContentAll, saveProgress } from "../../services/apiCategorie";

const rowsPerPage = 10;

function CategoryAdminPanel({ onRefresh }) {
  const [categories, setCategories] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [form, setForm] = useState({ title: "" });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const refresh = async () => {
    const data = await fetchContentAll();
    setCategories(data);
  };

  useEffect(() => {
    refresh();
  }, []);

  useEffect(() => {
    setFiltered(
      categories.filter((category) =>
        category.title.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [categories, search]);

  const displayed = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await saveProgress({ title: form.title });
      setOpenModal(false);
      setForm({ title: "" });
      await refresh();
      onRefresh?.();
    } catch (error) {
      console.error("Erreur ajout catégorie:", error);
    }
  };

  return (
    <div className="section-right">
      <div className="filter-bar">
        <input type="text" placeholder="Filtrer les catégories..." value={search} onChange={(event) => setSearch(event.target.value)} />
        <div>
          <button onClick={() => setOpenModal(true)} className="btn-add">
            + Ajouter catégorie
          </button>
        </div>
      </div>

      <div className="vc-card">
        <table className="vc-table video-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Catégorie</th>
            </tr>
          </thead>
          <tbody>
            {displayed.map((category) => (
              <tr key={category.id}>
                <td>{category.id}</td>
                <td>{category.title}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <span>
          Rows per page: <b>{rowsPerPage}</b>
        </span>
        <span>
          {page} – {Math.ceil(filtered.length / rowsPerPage)} of {filtered.length}
        </span>
        <button disabled={page === 1} onClick={() => setPage((current) => current - 1)}>
          ‹
        </button>
        <button disabled={page * rowsPerPage >= filtered.length} onClick={() => setPage((current) => current + 1)}>
          ›
        </button>
      </div>

      <AnimatePresence>
        {openModal ? (
          <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <motion.div className="modal" initial={{ scale: 0.9, y: 50 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 50 }}>
              <h3>Nouvelle catégorie</h3>
              <button className="vc-modal-close" onClick={() => setOpenModal(false)}>
                ✕
              </button>

              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Catégorie vidéo"
                  value={form.title}
                  required
                  onChange={(event) => setForm({ title: event.target.value })}
                />

                <div className="modal-actions">
                  <button type="button" className="badge admin" onClick={() => setOpenModal(false)}>
                    Annuler
                  </button>
                  <button type="submit" className="badge acteur">
                    Enregistrer
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}

export default CategoryAdminPanel;
